import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-xia",
  "use": "icon-icon-xia-usage",
  "viewBox": "0 0 9 8",
  "content": "<symbol viewBox=\"0 0 9 8\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-icon-xia\">\n    <title>下</title>\n    <g id=\"icon-icon-xia_金融产品\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g transform=\"translate(-245.000000, -415.000000)\" fill=\"#999999\" fill-rule=\"nonzero\" id=\"icon-icon-xia_下\">\n            <path d=\"M253.728675,416.906162 L250.671592,422.084667 C250.489167,422.393612 250.174337,422.548084 249.860979,422.548084 C249.547621,422.548084 249.232791,422.393612 249.050366,422.084667 L245.993283,416.906162 C245.622549,416.277974 246.075668,415.486486 246.803896,415.486486 L252.918062,415.486486 C253.647761,415.486486 254.099409,416.279445 253.728675,416.906162 Z\" />\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-xia.svg
// module id = wS9n
// module chunks = 3